<template>
  <div class="dojos">
  
  <div class="fullscreen-container" v-if="mode === 'map' && dojos != null">
      <!--  :center="{lat: location.latitude || 49, lng: location.longitude || 8}" -->
      <gmap-map
        :center="{lat: 50, lng: 9}"
        :zoom="7"
        map-type-id="roadmap"
        style="width: 100%; height: 100%;"        
      >
        <gmap-info-window :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false" v-if="infoContent.id != 0">
          <h2>{{infoContent.title}}</h2>
          <img class="dojo-map-logo" :src="logoPath + infoContent.id + '.jpg'" @error="onLogoImageError" style="max-width: 220px;"/>
          <div>
            <button class="flat" @click="goDojo(infoContent)">{{$t('message.more')}}</button>
          </div>
        </gmap-info-window>
        <gmap-marker v-show="m.BG != 0 && m.id != 0"
          :key="index"
          v-for="(m, index) in dojos"
          :position="convertToPosition(m.BG, m.LG)"
          :clickable="true"       
          @click="onMarkerClicked(m, index)"
        ></gmap-marker>
      </gmap-map>
    </div>
    <!--div class="toolbar">
      <div class="toolbar-button" @click="mode = 'list'"><icon name="list-ul"></icon></div>
      <div class="toolbar-button" @click="mode = 'map'"><icon name="globe"></icon></div> 
    </div--> 

    <div class="maps-search-outer">
      <cool-select
        v-model="selectedDojo"
        :items="dojos"
        :placeholder="$t('message.search')"
        item-value="id"
        item-text="dojo">
        <template slot="item" slot-scope="{ item: dojo }">
          <div class="autocomplete-list-item" @click="goDojo(dojo)">
            <img :src="logoPath + dojo.id + '.jpg'" @error="onLogoImageError"/>
            <div>
              <b>{{ dojo.dojo }}</b>
            </div>
          </div>
        </template>        
      </cool-select>
    </div>
  
    <div class="container"> 
      <h1 class="headline" v-if="mode ==='list'">GCO Dojos</h1>
      <div class="loading" v-if="dojos == null"></div> 
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { CoolSelect } from 'vue-cool-select'

export default {
  name: 'dojos',
  data () {
    return {
      mode: 'map',
      location: {
        latitude: 44,
        longitude: 47
      },
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoContent: {
        title: '',
        id: 0
      },
      infoWinOpen: false,
      searchString: '',
      searchResults: [],
      selectedDojo: null
    }
  },
  components: {
    CoolSelect
  },
  methods: {
    initSearchField: function () {
      this.searchText = ''
    },
    getDojos: function () {
      this.$store.dispatch('dojos/getAll')
    },
    setLocation: function (loc) {
      this.location = loc.coords
      console.log(this.location)
    },
    convertToPosition: function (lat, lng) {
      return { lat: Number(lat), lng: Number(lng) }
    },
    goDojo: function (item) {
      var breadcrumb = {
        name: item.dojo ? item.dojo : item.title,
        route: '/dojo/' + item.id
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
      console.log('godojo')
    },
    onMarkerClicked (marker, idx) {
      this.infoWinOpen = true
      this.infoWindowPos = this.convertToPosition(marker.BG, marker.LG)
      this.infoContent.title = marker.dojo
      this.infoContent.id = marker.id
      console.log(marker)
      console.log(idx)
    },
    onAutoCompleteInput: function (keyword) {
      this.debugMessage = keyword
      if (keyword.length > 3) {
        this.getMembers(keyword)
        // alert(keyword)
      }
    },
    onImageError: function (event) {
      // console.log('error')
      event.target.src = 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
  },
  watch: {
    searchString: function () {
      var searchString = this.searchString
      if (this.dojos !== null && searchString.length > 3) {
        this.searchResults = _.filter(this.dojos, function (o) { return (o.dojo).toUpperCase().includes(searchString.toUpperCase()) })
        // this.goFoundInList()
      } else {
        this.searchResults = []
      }
    }
  },
  computed: {
    ...mapGetters({
      dojos: 'dojos/list',
      logoPath: 'dojos/logoPath'
    })
  },
  created: function () {
    this.getDojos()
    navigator.geolocation.getCurrentPosition(this.setLocation)
  }
}
</script>
